import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { Avatar, Space } from 'antd';
import { KEYS_DAYS_IN_WEEK } from 'configs/localData';
import { RequiredDaysStyles } from './styles';

const RequiredDays = ({ requiredDays = [], type = 'primary' }) => {
  const getClassActive = (value) =>
    requiredDays.includes(value) ? 'avatar-active' : 'avatar-disabled';

  return (
    <RequiredDaysStyles className={`required-day-${type}`}>
      <Space size={6} align="center" wrap>
        {KEYS_DAYS_IN_WEEK.map((item, index) => (
          <Avatar
            key={String(index)}
            className={`day-item ${getClassActive(item.value)}`}
          >
            {i18next.t(item.text)}
          </Avatar>
        ))}
      </Space>
    </RequiredDaysStyles>
  );
};

RequiredDays.propTypes = {
  requiredDays: PropTypes.array,
  type: PropTypes.oneOf(['primary', 'secondary']),
};

export default RequiredDays;
